<template>
    <div>
        <div v-if="showAlert" class="alert d-flex" :class="percentageMsg.classes">
            <span>{{ percentageMsg.text }}</span>
            <span class="ml-auto">{{ maxPercent }}%</span>
        </div>
        <div class="card text-center">
            <div class="tabs">
                <div class="card-header">
                    <ul class="nav nav-tabs card-header-tabs">
                        <li class="nav-item" v-for="tab in tabs">
                            <div class="nav-link" @click="selectTab(tab)" :class="{'active': currentTab.name === tab.name}">
                                <span>{{tab.name}}</span>
                                <span v-if="tab.count" class="badge badge-dark text-white ml-1">{{tab.count}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="tab-content">
                    <div class="tab-pane card-body" v-for="tab in tabs" :class="{'active': currentTab.name === tab.name}">
                        <slot :name="tab.slot"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import constants from '../../../constants.js';

    export default {
        name: 'Widget',
        props: {
            tabs: Array,
            maxPercent: {
                type: Number,
                default: 0
            },
            showAlert: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            percentageMsg,
        },
        data() {
            return {
                currentTab: this.tabs[0]
            }
        },
        methods: {
            selectTab(tab) {
                this.currentTab = tab;
            }
        }
    };

    function percentageMsg() {
        return constants.DUPLICATES_MESSAGES.find(item => {
            return item.min <= this.maxPercent && this.maxPercent <= item.max;
        });
    }
</script>
